export var CatalogSource;
(function (CatalogSource) {
    CatalogSource["USSF"] = "USSF";
    CatalogSource["CELESTRAK"] = "Celestrak";
    CatalogSource["UNIV_OF_MICH"] = "University of Michigan";
    CatalogSource["CALPOLY"] = "CalPoly";
    CatalogSource["NUSPACE"] = "NuSpace";
    CatalogSource["VIMPEL"] = "JSC Vimpel";
    CatalogSource["TLE_TXT"] = "TLE.txt";
    CatalogSource["EXTRA_JSON"] = "extra.json";
})(CatalogSource || (CatalogSource = {}));
